'use strict';

/*global services*/

$(document).bind('pageLoaded', function () {
    $('#form-basket').validate({
        rules: {
            deposit_payment_type: {
                required: services.get('configurations').param('DepositRequired') === '1'
            },
            guarantee_payment_type: {
                required: services.get('configurations').param('GuaranteeRequired') === '1'
            },
            login_email: {
                required: false,
                email: true
            },
            email: {
                required: true,
                remote: $.remoteCORS('check-registration-email')
            },
            check_pswd: {
                required: false,
                equalTo: 'input[name=pswd]'
            }
        },
        messages: {
            email: {
                remote: services.get('translator').trans('EmailAlreadyExists')
            }
        }
    });
});
